<template>
  <div class="poor-item">
    <div class="poor-index">{{index+1}}</div>
    <div class="kv-list">
      <div class="kv-item" v-for="kv in kvList" :key="kv.key">
        <div class="key">{{kv.key}}</div>
        <div class="value">{{kv.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  const PoorTypeMap = {
    '1': '扶贫户', '2': '低保户', '3': '扶贫低保户', '4': '五保户',
    '5': '一般贫困户', '6': '建档立卡', '7': '一般农户'
  };
  const PovertySituationMap = { '0': '未脱贫', '1': '已脱贫', '2': '返贫' };

  export default {
    props: {
      data: Object,
      index: Number
    },
    computed: {
      kvList() {
        const list = [];
        const { Name, FamilyNumber, Address, PoorType, OrgName, ProductName, PovertySituation } = this.data;
        list.push({ key: '户主', value: Name });
        list.push({ key: '家庭人口', value: FamilyNumber });
        list.push({ key: '所在地', value: Address });
        list.push({ key: '贫困类型', value: PoorTypeMap[PoorType] });
        list.push({ key: '帮扶企业', value: OrgName });
        list.push({ key: '产品', value: ProductName });
        list.push({ key: '脱贫状态', value: PovertySituationMap[PovertySituation] });
        return list;
      }
    }
  }
</script>

<style lang="less" scoped>
  @fz: 75;
  .poor-item {
    position: relative;
    border-radius: 0.16rem;
    background-color: #ffffff;
    width: 580px;
    height: 100%;
    overflow: hidden;
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    margin-right: 30px;
    padding: .30rem 30px;
    line-height: 1;
    &:last-child {
      margin-right: 0;
    }
  }

  .poor-index {
    position: absolute;
    left: 0;
    top: 20px;
    width: 85px;
    height: 65px;
    text-align: center;
    line-height: 65px;
    color: #ff4d00;
    font-size: 55px;
    border-right: 1px solid #f0f0f0;
  }

  .kv-list {
    margin-top: 75px;
  }

  .kv-item {
    display: block;
    padding: 0;
    margin: 0;
    margin-bottom: 0.12rem;
    line-height: 30px;
    white-space: nowrap;
  }

  .key {
    font-size: 24px;
    color: #333;
    font-weight: bold;
    display: inline-block;
    vertical-align: top;
    width: 100px;
    white-space: nowrap;
  }

  .value {
    font-size: 24px;
    color: #333;
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    width: 385px;
  }
</style>



// WEBPACK FOOTER //
// poorItem.vue?4187af24